import { PrivateInterceptor } from "../../../Base/interceptors/PrivateInterceptor";

// OBTENER REQUISAS PARA SCREEN
export const getPurchase = async () => {
  const respuesta = await PrivateInterceptor(
    `Compras/RequisasCompras/Requisas`,
    "GET"
  );
  return respuesta;
};

export const getPurchaseId = async (PurchaseRequest) => {
  const result = await PrivateInterceptor(`Compras/RequisasCompras/RequisasId`, 'POST', {PurchaseRequest} )
  return result;
}

export const getPurchaseSinCancelar = async (PurchaseRequest) => {
  return await PrivateInterceptor('Compras/RequisasCompras/listadoRequisasPorPurchaseRequest', 'POST', {PurchaseRequest});
}

// OBTENER LISTADO GENERAL DE REQUISAS
export const getPurchaseList = async () => {
  const respuesta = await PrivateInterceptor(
    `Compras/RequisasCompras/RequisasListado`,
    "GET"
  );
  return respuesta;
};

// LISTADO REQUISAS AUTORIZAR BODEGA
export const getListaRequisasAutorizarBodega = (dates) => {
  const respuesta = PrivateInterceptor("Compras/LiberarBodega", "GET", dates);
  return respuesta;
};

export const guardarEncabezadoRequisa = async (body) => {
  const respuesta = await PrivateInterceptor('PursacheRequest/encabezadoRequisa', 'POST', body);
  return respuesta;
}

// LISTADO REQUISAS AUTORIZAR BODEGA
export const ObtenerSiguienteNoRequisa = () => {
  const respuesta = PrivateInterceptor("Compras/RequisasCompras/ObtenerSiguienteNoRequisa", "GET");
  return respuesta;
};

// GUARDAR REQUISA
export const GuardarRequisa = (data, data2) => {
  const respuesta = PrivateInterceptor("Compras/RequisasCompras/GuardarRequisa", "POST", {Encabeazado: data, Detalle: data2});
  return respuesta;
};

// ELIMINAR ITEM REQUISA
export const EliminarItemRequisa = (data) => {
  const respuesta = PrivateInterceptor("Compras/RequisasCompras/EliminarItemRequisa", "POST",{Detalle: data});
  return respuesta;
};

// ELIMINAR  REQUISA COMPLETA
export const EliminarRequisa = (data) => {
  const respuesta = PrivateInterceptor("Compras/RequisasCompras/EliminarRequisa", "POST",{Detalle: data});
  return respuesta;
};

// OBTIENER DETALLE DE UNA REQUISA
export const getPurchaseRequestDetailAuth = async (IdPurchaseRequest) => {
  const result = await PrivateInterceptor('Compras/RequisasCompras/ListadoOrdenesCompraAuthPurchaseRequest', 'POST', { IdPurchaseRequest })
  return result;
}

export const ListadoOrdenesCompraAuth = async () => {
  const result = await PrivateInterceptor('Compras/RequisasCompras/ListadoOrdenesCompraAuth', 'GET')
  return result;
}

// Obtener requisas por IdCurrency(moneda) e IdVendor(Proveedor)
export const getPurchaseByCurrency = async (idCurrency, idVendor) => {
    // Convertir los valores a cadenas
    const currencyId = String(idCurrency);
    const vendorId = String(idVendor);
    
    // Construir el cuerpo de la solicitud POST
    const body = {
      IdCurrency: currencyId,
      IdVendor: vendorId
    };
    // Llamar a la API con el método POST y el cuerpo de la solicitud
    const respuesta = await PrivateInterceptor('Compras/RequisasCompras/RequisasPorIdCurrency', 'POST', body);
    return respuesta;
};

// Modificada la función para aceptar los parámetros IdCurrency e IdVendor
export const RequisasPorIdCurrencyIdVendor = async (IdCurrency, IdVendor) => {
  // Construir la ruta con los parámetros proporcionados
  const route = `Compras/RequisasCompras/RequisasPorIdCurrencyIdVendor/${IdCurrency}/${IdVendor}`;
  
  // Llamar a la API utilizando el interceptor privado con el método GET
  const result = await PrivateInterceptor(route, 'GET');
  
  return result;
}

// EDITAR REQUISA
export const EditarRequisa = (data, data2) => {
  const respuesta = PrivateInterceptor("Compras/RequisasCompras/EditarRequisa", "POST", {Encabeazado: data, Detalle: data2});
  return respuesta;
};
